import React from 'react';

export default function TopHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Brim */}
      <ellipse cx="20" cy="32" rx="18" ry="4" fill="#2C2419" />
      {/* Crown */}
      <rect x="8" y="10" width="24" height="22" rx="2" fill="#2C2419" />
      {/* Top */}
      <ellipse cx="20" cy="10" rx="12" ry="3" fill="#3A3020" />
      {/* Band */}
      <rect x="8" y="24" width="24" height="4" fill="#E8762E" />
    </svg>
  );
}
